<template>
    <b-select
        v-validate="{ required: true }"
        :value="value"
        placeholder="Select a Portfolio"
        expanded
        :loading="! ownerGroups"
        data-vv-name="Portfolio"
        @input.native="onInput"
    >
        <option value="">
            Select a Portfolio
        </option>
        <template v-if="ownerGroups">
            <option
                v-for="option in ownerGroups"
                :key="option.OwnerPK"
                :value="option.OwnerPK"
            >
                {{ option.optionLabel | truncate(45) }}
            </option>
        </template>
    </b-select>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: {
        value: {
            type: String,
            default: '',
        },
    },

    computed: {
        ...mapState('ownerGroup', [
            'ownerGroups',
        ]),
    },

    mounted() {
        this.getOwnerGroups();
    },

    methods: {
        getOwnerGroups() {
            this.$store.dispatch('ownerGroup/getOwnerGroups');
        },
        onInput(event) {
            // emit event to update parent data
            this.$emit('input', event.target.value);
        },
    },
};
</script>
